<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Habilitações/Divergências</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Início',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Habilitações/Divergências',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn outlined color="primary" :loading="exporting" @click="exportSheet">
                            <v-icon left small>mdi-file-excel-outline</v-icon>Exportar planilha
                        </v-btn>
                        <v-btn outlined color="primary" @click="openImportDialog">
                            <v-icon left small>mdi-upload-outline</v-icon>Importar análise
                        </v-btn>
                        <v-btn outlined color="primary" :loading="zipping" @click="downloadDocuments">
                            <v-icon left small>mdi-folder-zip-outline</v-icon>Documentos (.zip)
                        </v-btn>
                        <v-btn color="primary" elevation="0" @click="openDeadlineDialog">Prazo do contraditório</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-select dense :items="dataset.eventStatus" label="Status" v-model="dataList.filter.status"
                                        item-value="id" item-text="name" outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col>
                                    <v-select dense :items="dataset.eventTypes" label="Tipo" v-model="dataList.filter.type"
                                        item-value="id" item-text="name" outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col>
                                    <v-autocomplete dense :items="dataset.clients" label="Caso" v-model="dataList.filter.client_id"
                                        item-value="id" item-text="name" outlined hide-details="auto" clearable
                                        no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                                        >Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Hab/Div</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum usuário foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.user.name`]="{ item }">
                                <span class="list-item-title text-capitalize">{{ item.user.name }}</span><br />
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip :color="getColorByStatus(item.status)" label text-color="white">
                                    {{ item.status | enum(dataset.eventStatus, "id", "name") }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                <v-chip :color="item.type == 2 ? 'copper' : 'primary'" label small text-color="white">
                                    {{ item.type == 2 ? 'Divergência' : 'Habilitação' }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.contradictory_date`]="{ item }">
                                <span v-if="item.contradictory_date">{{ item.contradictory_date | defaultDate("DD/MM/YYYY") }}</span>
                                <span v-else class="grey--text">—</span>
                            </template>

                            <template v-slot:[`item.contradictories`]="{ item }">
                                <v-chip v-if="Number(item.__meta__ && item.__meta__.contradictories_count)" small color="green" text-color="white">
                                    Recebido
                                </v-chip>
                                <span v-else class="grey--text">—</span>
                            </template>

                            <template v-slot:[`item.admin`]="{ item }">
                                {{ item.admin && item.admin.name ? item.admin.name : 'N/A' }}
                            </template>

                            <template v-slot:[`item.analyzed_at`]="{ item }">
                                <span v-if="item.analyzed_at && item.analyzed_at !== '0000-00-00 00:00:00'"> {{
                                    item.analyzed_at |
                                    defaultDate("DD/MM/YYYY HH:mm:ss") }}</span>
                                <span v-else>N/A</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon :disabled="!$check('users/1', ['PATCH'])" @click="viewItem(item)" size="large"
                                    class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="importing.dialog" max-width="720" :persistent="importing.loading">
            <v-card>
                <v-card-title class="d-flex align-center">
                    Importar análise das Hab/Div
                    <v-spacer></v-spacer>
                    <v-btn small text color="primary" @click="formatDialog = true">
                        <v-icon left small>mdi-help-circle-outline</v-icon> Formato e modelo da planilha
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <p>
                        Use a planilha gerada em <strong>Exportar planilha</strong>, com as colunas <strong>Status</strong>,
                        <strong>Valor</strong>, <strong>Classe</strong> e <strong>Moeda</strong> preenchidas. Linhas sem Status
                        são ignoradas. Se houver qualquer erro, nada é gravado.
                    </p>
                    <v-file-input v-model="importing.file" dense outlined accept=".xlsx,.xls,.csv" label="Planilha da análise"
                        prepend-icon="" prepend-inner-icon="mdi-paperclip" hide-details="auto" :disabled="importing.loading"
                        @change="importing.result = null" />

                    <v-alert v-if="importing.result && importing.result.applied" type="success" text dense class="mt-4 mb-0">
                        Análise importada: {{ importing.result.events }} {{ importing.result.events === 1 ? 'pedido' : 'pedidos' }} e
                        {{ importing.result.items }} {{ importing.result.items === 1 ? 'crédito' : 'créditos' }} atualizados.
                    </v-alert>
                    <template v-if="importing.result && !importing.result.applied">
                        <v-alert type="error" text dense class="mt-4 mb-2">
                            A planilha tem {{ importing.result.errors.length }}
                            {{ importing.result.errors.length === 1 ? 'erro' : 'erros' }}; nada foi gravado. Corrija e importe de novo.
                        </v-alert>
                        <v-simple-table dense class="import-errors">
                            <thead><tr><th style="width: 90px">Linha</th><th>Problema</th></tr></thead>
                            <tbody>
                                <tr v-for="(error, index) in importing.result.errors" :key="index">
                                    <td>{{ error.line }}</td><td>{{ error.message }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </template>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text :disabled="importing.loading" @click="importing.dialog = false">Fechar</v-btn>
                    <v-btn color="primary" elevation="0" :loading="importing.loading" :disabled="!importing.file"
                        @click="importAnalysis">Importar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- FORMATO E MODELO DA PLANILHA DA ANÁLISE -->
        <v-dialog v-model="formatDialog" max-width="960px">
            <v-card>
                <v-card-title class="font-weight-bold">Formato da planilha da análise</v-card-title>

                <v-card-text class="black--text">
                    <p>
                        A análise das habilitações e divergências é feita fora da plataforma, na própria planilha
                        exportada. Aceitamos arquivos <strong>XLSX</strong> ou <strong>CSV</strong> (vírgula ou
                        ponto-e-vírgula).
                    </p>

                    <ol class="mb-4">
                        <li>Filtre o <strong>caso</strong> na lista e baixe o modelo (é a planilha das Hab/Div do caso, uma linha por crédito).</li>
                        <li>Preencha as colunas <strong>Status</strong>, <strong>Valor</strong>, <strong>Classe</strong> e <strong>Moeda</strong>. Não altere as colunas <strong>ID Hab/Div</strong> e <strong>ID Item</strong>.</li>
                        <li>Importe o arquivo em <strong>Importar análise</strong>. Se houver qualquer erro, nada é gravado e a lista de erros indica a linha.</li>
                    </ol>

                    <v-simple-table dense class="format-table">
                        <thead>
                            <tr>
                                <th>Coluna</th>
                                <th>Preenchimento</th>
                                <th>O que informar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>ID Hab/Div</strong>, <strong>ID Item</strong></td>
                                <td>Obrigatória (já vem preenchida)</td>
                                <td>Identificam o pedido e o crédito. Não altere.</td>
                            </tr>
                            <tr>
                                <td><strong>Status</strong></td>
                                <td>Obrigatória para importar a linha</td>
                                <td>
                                    Aprovado, Aprovado parcialmente, Rejeitado ou Pendente. Linhas com Status vazio são ignoradas.
                                    Todas as linhas de um mesmo pedido (mesmo ID Hab/Div) devem ter o mesmo Status.
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Valor</strong></td>
                                <td>Obrigatória em Aprovado parcialmente</td>
                                <td>
                                    Valor reconhecido (ex.: 45.000,00 ou 45000.00). Em Aprovado, vazio = valor solicitado.
                                    Em Rejeitado, o valor é zerado.
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Classe</strong></td>
                                <td>Opcional</td>
                                <td>
                                    Classe I - Trabalhista, Classe II - Garantia Real, Classe III - Quirografários,
                                    Classe IV - ME/EPP, Extraconcursal/Pago (Extraconcursais na falência) ou Tributário.
                                    Também aceita o número (1 a 6). Vazio = classe solicitada.
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Moeda</strong></td>
                                <td>Opcional</td>
                                <td>BRL (R$), USD ou EUR. Vazio = moeda solicitada.</td>
                            </tr>
                            <tr>
                                <td>Demais colunas (Credor, CPF/CNPJ, Caso, Valor solicitado…)</td>
                                <td>Informativas</td>
                                <td>Servem de apoio à análise e são ignoradas na importação.</td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <div class="mt-4">
                        <v-btn color="primary" small elevation="0" :loading="exporting" @click="downloadTemplate">
                            <v-icon left small>mdi-file-excel-outline</v-icon> Baixar modelo do caso (.xlsx)
                        </v-btn>
                        <v-btn color="primary" small outlined class="ml-2" @click="downloadExample">
                            Baixar exemplo preenchido (.xlsx)
                        </v-btn>
                        <div v-if="!dataList.filter.client_id" class="caption mt-2 grey--text text--darken-1">
                            Sem caso filtrado, o modelo traz as Hab/Div de todos os casos.
                        </div>
                    </div>

                    <p class="mt-5 font-weight-bold">Exemplo de registros de um arquivo válido:</p>

                    <v-simple-table dense class="format-table">
                        <thead>
                            <tr>
                                <th v-for="column in exampleColumns" :key="column"
                                    :class="{ 'format-table__analysis': analysisColumns.includes(column) }">{{ column }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in exampleRows" :key="index">
                                <td v-for="(value, column) in row" :key="column"
                                    :class="{ 'format-table__analysis': analysisColumns.includes(column) }">{{ value }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn text color="primary" @click="formatDialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deadline.dialog" max-width="560">
            <v-card>
                <v-card-title>Prazo do contraditório</v-card-title>
                <v-card-text>
                    <p>Define a data limite para a devedora enviar o contraditório nas habilitações e divergências do caso. Deixe o período em branco para aplicar a todas.</p>
                    <v-form ref="deadlineForm">
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete dense outlined :items="dataset.clients" item-value="id" item-text="name" label="Caso"
                                    v-model="deadline.client_id" :rules="[$rules.required]" hide-details="auto" />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field dense outlined type="date" label="Abertas a partir de" v-model="deadline.opened_from" hide-details="auto" />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field dense outlined type="date" label="Abertas até" v-model="deadline.opened_to" hide-details="auto" />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field dense outlined type="date" label="Data limite do contraditório" v-model="deadline.contradictory_date"
                                    :rules="[$rules.required]" hide-details="auto" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="deadline.dialog = false">Cancelar</v-btn>
                    <v-btn color="primary" elevation="0" :loading="deadline.loading" @click="saveDeadline">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import eventStatus from "@/common/data/event-status.data";

Vue.use(VueLodash)

export default {
    name: "UserList",

    data: () => ({
        dataset: {
            eventStatus: [{ id: "", name: "Todos" }, ...eventStatus],
            eventTypes: [{ id: "", name: "Todos" }, { id: 1, name: "Habilitação" }, { id: 2, name: "Divergência" }],
            clients: [],
            data: {}
        },
        exporting: false,
        zipping: false,
        formatDialog: false,
        analysisColumns: ['Status', 'Valor', 'Classe', 'Moeda'],
        exampleColumns: ['ID Hab/Div', 'ID Item', 'Credor', 'Valor solicitado', 'Status', 'Valor', 'Classe', 'Moeda'],
        exampleRows: [
            { 'ID Hab/Div': 23, 'ID Item': 26, 'Credor': 'Maria Aparecida Souza', 'Valor solicitado': '48.500,00', 'Status': 'Aprovado parcialmente', 'Valor': '45.000,00', 'Classe': 'Classe III - Quirografários', 'Moeda': 'BRL' },
            { 'ID Hab/Div': 23, 'ID Item': 27, 'Credor': 'Maria Aparecida Souza', 'Valor solicitado': '3.250,90', 'Status': 'Aprovado parcialmente', 'Valor': '3.250,90', 'Classe': '', 'Moeda': '' },
            { 'ID Hab/Div': 25, 'ID Item': 29, 'Credor': 'Transportes Silva LTDA', 'Valor solicitado': '21.780,00', 'Status': 'Aprovado', 'Valor': '', 'Classe': 'Classe IV - ME/EPP', 'Moeda': 'BRL' },
            { 'ID Hab/Div': 31, 'ID Item': 40, 'Credor': 'João Pedro Lima', 'Valor solicitado': '8.000,00', 'Status': 'Rejeitado', 'Valor': '', 'Classe': '', 'Moeda': '' },
        ],
        importing: {
            dialog: false,
            loading: false,
            file: null,
            result: null,
        },
        deadline: {
            dialog: false,
            loading: false,
            client_id: null,
            opened_from: "",
            opened_to: "",
            contradictory_date: "",
        },
        dataList: {
            filter: {
                name: "",
                status: "",
                type: "",
                client_id: null
            },
            headers: [
                { text: "Credor", value: "user.name" },
                { text: "Tipo", value: "type" },
                { text: "Caso", value: "client.name" },
                { text: "Solicitado em", value: "created_at" },
                { text: "Prazo contraditório", value: "contradictory_date" },
                { text: "Contraditório", value: "contradictories" },
                { text: "Analisado por", value: "admin" },
                { text: "Analisado em", value: "analyzed_at" },
                { text: "Status", value: "status" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
        this.loadClients();
    },

    methods: {
       
        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                case 3:
                    return 'indigo darken-1'
                default:
                    break;
            }
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        currentSearch() {
            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : {};

            if(this.dataList.filter.status === 0) search.status = 0

            return search
        },

        // Download autenticado (o token vai no header do axios); erros chegam como Blob e viram JSON.
        async download(url, params, fallbackName) {
            try {
                const result = await axios.get(url, { params, responseType: 'blob' })
                const disposition = result.headers['content-disposition'] || ''
                const match = disposition.match(/filename="?([^";]+)"?/)
                const link = document.createElement('a')
                link.href = URL.createObjectURL(result.data)
                link.download = match ? match[1] : fallbackName
                document.body.appendChild(link)
                link.click()
                link.remove()
                setTimeout(() => URL.revokeObjectURL(link.href), 1000)
            } catch (error) {
                if (error.response && error.response.data instanceof Blob) {
                    try { error.response.data = JSON.parse(await error.response.data.text()) } catch (e) { /* mantém */ }
                }
                this.$dialog.notify.error(this.$codes(error) || 'Não foi possível gerar o arquivo.', { position: 'top-right', timeout: 6000 })
            }
        },

        async exportSheet() {
            this.exporting = true
            await this.download('/api/admin/user-events/export', { search: this.currentSearch() }, 'hab-div.xlsx')
            this.exporting = false
        },

        // O modelo é a planilha exportada (já traz ID Hab/Div e ID Item de cada crédito).
        async downloadTemplate() {
            this.exporting = true
            await this.download('/api/admin/user-events/export', { search: this.currentSearch() }, 'hab-div-modelo.xlsx')
            this.exporting = false
        },

        async downloadExample() {
            try {
                const XLSX = await import('xlsx')
                const sheet = XLSX.utils.json_to_sheet(this.exampleRows, { header: this.exampleColumns })
                sheet['!cols'] = this.exampleColumns.map((column) => ({ wch: Math.max(14, column.length + 4) }))
                const book = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(book, sheet, 'Hab-Div')
                const blob = new Blob([XLSX.write(book, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'hab-div-exemplo-analise.xlsx'
                link.click()
                setTimeout(() => URL.revokeObjectURL(link.href), 1000)
            } catch (error) {
                this.$dialog.notify.error('Não foi possível gerar o exemplo.', { position: 'top-right', timeout: 5000 })
            }
        },

        async downloadDocuments() {
            if (!this.dataList.filter.client_id) {
                this.$dialog.notify.info('Escolha um caso no filtro para baixar os documentos das Hab/Div dele.', { position: 'top-right', timeout: 5000 })
                return
            }
            this.zipping = true
            this.$dialog.notify.info('Preparando o .zip com os documentos. Em casos grandes isso pode levar alguns minutos.', { position: 'top-right', timeout: 6000 })
            await this.download('/api/admin/user-events/documents', { search: this.currentSearch() }, 'hab-div-documentos.zip')
            this.zipping = false
        },

        openImportDialog() {
            this.importing = { dialog: true, loading: false, file: null, result: null }
        },

        async importAnalysis() {
            if (!this.importing.file) return
            this.importing.loading = true
            this.importing.result = null
            try {
                const form = new FormData()
                form.append('file', this.importing.file)
                const result = await axios.post('/api/admin/user-events/import-analysis', form)
                this.importing.result = result.data.content
                if (this.importing.result.applied) this.load()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Não foi possível importar a planilha.', { position: 'top-right', timeout: 6000 })
            } finally {
                this.importing.loading = false
            }
        },

        async load() {

            const search = this.currentSearch()
            
            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;
            
            try {
                const result = await axios.get('/api/admin/user-events/list', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadClients() {
            try {
                const result = await axios.get('/api/clients', { params: { page: 1, limit: 1000 } });
                this.dataset.clients = result.data.content.data;
            } catch (error) {
                this.dataset.clients = [];
            }
        },

        openDeadlineDialog() {
            this.deadline = {
                dialog: true,
                loading: false,
                client_id: this.dataList.filter.client_id || null,
                opened_from: "",
                opened_to: "",
                contradictory_date: "",
            };
            this.$nextTick(() => this.$refs.deadlineForm && this.$refs.deadlineForm.resetValidation());
        },

        async saveDeadline() {
            if (!this.$refs.deadlineForm.validate()) return;

            this.deadline.loading = true;

            try {
                const result = await axios.post('/api/admin/user-events/contradictory-date', {
                    client_id: this.deadline.client_id,
                    contradictory_date: this.deadline.contradictory_date,
                    opened_from: this.deadline.opened_from || null,
                    opened_to: this.deadline.opened_to || null,
                });

                const affected = result.data.content.affected;
                this.deadline.dialog = false;
                this.$dialog.notify.success(`Prazo definido em ${affected} ${affected === 1 ? 'pedido' : 'pedidos'}.`, { position: 'top-right', timeout: 4000 });
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.deadline.loading = false;
            }
        },

        viewItem(item) {
            this.$router.push(`divergencias/${item.id}`);
        },
    },
};
</script>
<style scoped>
.format-table td {
    vertical-align: top;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}

.format-table__analysis {
    background: #fbf1e9;
}

.import-errors {
    max-height: 320px;
    overflow-y: auto;
}
</style>
